import { render } from "./PimProductsOverviewTableItem.vue?vue&type=template&id=aa74e1e0&scoped=true&ts=true"
import script from "./PimProductsOverviewTableItem.vue?vue&type=script&lang=ts"
export * from "./PimProductsOverviewTableItem.vue?vue&type=script&lang=ts"

import "./PimProductsOverviewTableItem.vue?vue&type=style&index=0&id=aa74e1e0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa74e1e0"]])

export default __exports__